import { ERegistrationFailedReasonCode, ERegistrationFailedReason, } from "../types/registration.types";
export var mapRegistrationFailedReasonCodeToReason = function (code) {
    switch (code) {
        case ERegistrationFailedReasonCode.GeneralError:
            return ERegistrationFailedReason.GeneralError;
        case ERegistrationFailedReasonCode.InvalidFormat:
            return ERegistrationFailedReason.InvalidFormat;
        case ERegistrationFailedReasonCode.AddressNotFound:
            return ERegistrationFailedReason.AddressNotFound;
        case ERegistrationFailedReasonCode.DuplicatedRequest:
            return ERegistrationFailedReason.DuplicatedRequest;
        default:
            return null;
    }
};
